import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import FeaturesSection from '../components/FeaturesSection';
import TestimonialsSection from '../components/TestimonialsSection';
import CallToAction from '../components/CallToAction';

function LandingPage() {
  const { loginWithRedirect } = useAuth0();

  const handleGetStarted = () => {
    loginWithRedirect({ screen_hint: 'signup' });
  };

  return (
    <div className="flex flex-col min-h-[calc(100vh-6rem)]"> {/* Adjust min-height based on Navbar */}
      {/* Hero Section */}
      <HeroSection />

      {/* Features Section */}
      <FeaturesSection />

      {/* Testimonials Section */}
      {/* <TestimonialsSection /> */}

      {/* Call to Action */}
      <CallToAction onGetStarted={handleGetStarted} />

      {/* Footer */}
      {/* <Footer /> */}
    </div>
  );
}

export default LandingPage;
